class FacetFiltersForm extends HTMLElement {
  constructor() {
    super();
    this.onActiveFilterClick = this.onActiveFilterClick.bind(this);

    this.debouncedOnSubmit = debounce((event) => {
      this.onSubmitHandler(event);
    }, 500);

    const facetForm = this.querySelector('form');
    facetForm.addEventListener('input', this.debouncedOnSubmit.bind(this));

    const facetWrapper = this.querySelector('#FacetsWrapperDesktop');
    if (facetWrapper) facetWrapper.addEventListener('keyup', onKeyUpEscape);
  }

  static setListeners() {
    const onHistoryChange = (event) => {
      const searchParams = event.state ? event.state.searchParams : FacetFiltersForm.searchParamsInitial;
      if (searchParams === FacetFiltersForm.searchParamsPrev) return;
      FacetFiltersForm.renderPage(searchParams, null, false);
    };
    window.addEventListener('popstate', onHistoryChange);
  }

  static toggleActiveFacets(disable = true) {
    document.querySelectorAll('.js-facet-remove').forEach((element) => {
      element.classList.toggle('disabled', disable);
    });
  }

  static renderPage(searchParams, event, updateURLHash = true) {
    FacetFiltersForm.searchParamsPrev = searchParams;
    const sections = FacetFiltersForm.getSections();
    const countContainer = document.getElementById('ProductCount');
    const countContainerDesktop = document.getElementById('ProductCountDesktop');
    document.getElementById('ProductGridContainer').querySelector('.collection').classList.add('loading');
    if (countContainer) {
      countContainer.classList.add('loading');
    }
    if (countContainerDesktop) {
      countContainerDesktop.classList.add('loading');
    }

    sections.forEach((section) => {
      const url = `${window.location.pathname}?section_id=${section.section}&${searchParams}`;
      const filterDataUrl = (element) => element.url === url;

      FacetFiltersForm.filterData.some(filterDataUrl)
        ? FacetFiltersForm.renderSectionFromCache(filterDataUrl, event)
        : FacetFiltersForm.renderSectionFromFetch(url, event);
    });

    if (updateURLHash) FacetFiltersForm.updateURLHash(searchParams);
  }

  static renderSectionFromFetch(url, event) {
    fetch(url)
      .then((response) => response.text())
      .then((responseText) => {
        const html = responseText;
        FacetFiltersForm.filterData = [...FacetFiltersForm.filterData, { html, url }];
        FacetFiltersForm.renderFilters(html, event);
        FacetFiltersForm.renderProductGridContainer(html);
        FacetFiltersForm.renderProductCount(html);
        if (typeof initializeScrollAnimationTrigger === 'function') initializeScrollAnimationTrigger(html.innerHTML);
      });
  }

  static renderSectionFromCache(filterDataUrl, event) {
    const html = FacetFiltersForm.filterData.find(filterDataUrl).html;
    FacetFiltersForm.renderFilters(html, event);
    FacetFiltersForm.renderProductGridContainer(html);
    FacetFiltersForm.renderProductCount(html);
    if (typeof initializeScrollAnimationTrigger === 'function') initializeScrollAnimationTrigger(html.innerHTML);
  }

  static renderProductGridContainer(html) {
    document.getElementById('ProductGridContainer').innerHTML = new DOMParser()
      .parseFromString(html, 'text/html')
      .getElementById('ProductGridContainer').innerHTML;

    document
      .getElementById('ProductGridContainer')
      .querySelectorAll('.scroll-trigger')
      .forEach((element) => {
        element.classList.add('scroll-trigger--cancel');
      });
  }

  static renderProductCount(html) {
    const count = new DOMParser().parseFromString(html, 'text/html').getElementById('ProductCount').innerHTML;
    const container = document.getElementById('ProductCount');
    const containerDesktop = document.getElementById('ProductCountDesktop');
    container.innerHTML = count;
    container.classList.remove('loading');
    if (containerDesktop) {
      containerDesktop.innerHTML = count;
      containerDesktop.classList.remove('loading');
    }
  }

  static renderFilters(html, event) {
    const parsedHTML = new DOMParser().parseFromString(html, 'text/html');

    const facetDetailsElements = parsedHTML.querySelectorAll(
      '#FacetFiltersForm .js-filter, #FacetFiltersFormMobile .js-filter, #FacetFiltersPillsForm .js-filter'
    );
    const matchesIndex = (element) => {
      const jsFilter = event ? event.target.closest('.js-filter') : undefined;
      return jsFilter ? element.dataset.index === jsFilter.dataset.index : false;
    };
    const facetsToRender = Array.from(facetDetailsElements).filter((element) => !matchesIndex(element));
    const countsToRender = Array.from(facetDetailsElements).find(matchesIndex);

    facetsToRender.forEach((element) => {
      document.querySelector(`.js-filter[data-index="${element.dataset.index}"]`).innerHTML = element.innerHTML;
    });

    FacetFiltersForm.renderActiveFacets(parsedHTML);
    FacetFiltersForm.renderAdditionalElements(parsedHTML);

    if (countsToRender) FacetFiltersForm.renderCounts(countsToRender, event.target.closest('.js-filter'));
  }

  static renderActiveFacets(html) {
    const activeFacetElementSelectors = ['.active-facets-mobile', '.active-facets-desktop'];

    activeFacetElementSelectors.forEach((selector) => {
      const activeFacetsElement = html.querySelector(selector);
      if (!activeFacetsElement) return;
      document.querySelector(selector).innerHTML = activeFacetsElement.innerHTML;
    });

    FacetFiltersForm.toggleActiveFacets(false);
  }

  static renderAdditionalElements(html) {
    const mobileElementSelectors = ['.mobile-facets__open', '.mobile-facets__count', '.sorting'];

    mobileElementSelectors.forEach((selector) => {
      if (!html.querySelector(selector)) return;
      document.querySelector(selector).innerHTML = html.querySelector(selector).innerHTML;
    });

    document.getElementById('FacetFiltersFormMobile').closest('menu-drawer').bindEvents();
  }

  static renderCounts(source, target) {
    const targetElement = target.querySelector('.facets__selected');
    const sourceElement = source.querySelector('.facets__selected');

    const targetElementAccessibility = target.querySelector('.facets__summary');
    const sourceElementAccessibility = source.querySelector('.facets__summary');

    if (sourceElement && targetElement) {
      target.querySelector('.facets__selected').outerHTML = source.querySelector('.facets__selected').outerHTML;
    }

    if (targetElementAccessibility && sourceElementAccessibility) {
      target.querySelector('.facets__summary').outerHTML = source.querySelector('.facets__summary').outerHTML;
    }
  }

  static updateURLHash(searchParams) {
    history.pushState({ searchParams }, '', `${window.location.pathname}${searchParams && '?'.concat(searchParams)}`);
  }

  static getSections() {
    return [
      {
        section: document.getElementById('product-grid').dataset.id,
      },
    ];
  }

  createSearchParams(form) {
    const formData = new FormData(form);
    return new URLSearchParams(formData).toString();
  }

  onSubmitForm(searchParams, event) {
    FacetFiltersForm.renderPage(searchParams, event);
  }

  onSubmitHandler(event) {
    event.preventDefault();
    const sortFilterForms = document.querySelectorAll('facet-filters-form form');
    if (event.srcElement.className == 'mobile-facets__checkbox') {
      const searchParams = this.createSearchParams(event.target.closest('form'));
      this.onSubmitForm(searchParams, event);
    } else {
      const forms = [];
      const isMobile = event.target.closest('form').id === 'FacetFiltersFormMobile';

      sortFilterForms.forEach((form) => {
        if (!isMobile) {
          if (form.id === 'FacetSortForm' || form.id === 'FacetFiltersForm' || form.id === 'FacetSortDrawerForm') {
            const noJsElements = document.querySelectorAll('.no-js-list');
            noJsElements.forEach((el) => el.remove());
            forms.push(this.createSearchParams(form));
          }
        } else if (form.id === 'FacetFiltersFormMobile') {
          forms.push(this.createSearchParams(form));
        }
      });
      this.onSubmitForm(forms.join('&'), event);
    }
  }

  onActiveFilterClick(event) {
    event.preventDefault();
    FacetFiltersForm.toggleActiveFacets();
    const url =
      event.currentTarget.href.indexOf('?') == -1
        ? ''
        : event.currentTarget.href.slice(event.currentTarget.href.indexOf('?') + 1);
    FacetFiltersForm.renderPage(url);
  }
}

FacetFiltersForm.filterData = [];
FacetFiltersForm.searchParamsInitial = window.location.search.slice(1);
FacetFiltersForm.searchParamsPrev = window.location.search.slice(1);
customElements.define('facet-filters-form', FacetFiltersForm);
FacetFiltersForm.setListeners();

class PriceRange extends HTMLElement {
  constructor() {
    super();
    this.minSlider = this.querySelector('.price-range__slider--min');
    this.maxSlider = this.querySelector('.price-range__slider--max');
    this.minInput = this.querySelector('.price-range__input--min');
    this.maxInput = this.querySelector('.price-range__input--max');
    this.minValueDisplay = this.querySelector('.price-range__value-min');
    this.maxValueDisplay = this.querySelector('.price-range__value-max');
    this.sliderContainer = this.querySelector('.price-range__slider-container');
    
    if (this.minSlider && this.maxSlider) {
      this.minSlider.addEventListener('input', this.onSliderChange.bind(this));
      this.maxSlider.addEventListener('input', this.onSliderChange.bind(this));
      this.updateSliderRange();
    }
    
    if (this.minInput && this.maxInput) {
      this.minInput.addEventListener('input', this.onInputChange.bind(this));
      this.maxInput.addEventListener('input', this.onInputChange.bind(this));
      this.minInput.addEventListener('change', this.onInputChange.bind(this));
      this.maxInput.addEventListener('change', this.onInputChange.bind(this));
    }
    
    this.setMinAndMaxValues();
    this.updateDisplay();
  }
  
  updateSliderRange() {
    if (!this.sliderContainer || !this.minSlider || !this.maxSlider) return;
    
    const minValue = Number(this.minSlider.value);
    const maxValue = Number(this.maxSlider.value);
    const max = Number(this.maxSlider.getAttribute('max'));
    
    const minPercent = (minValue / max) * 100;
    const maxPercent = (maxValue / max) * 100;
    
    // 範囲を視覚的に表示
    if (!this.sliderContainer.querySelector('.price-range__range')) {
      const range = document.createElement('div');
      range.className = 'price-range__range';
      this.sliderContainer.appendChild(range);
    }
    
    const range = this.sliderContainer.querySelector('.price-range__range');
    range.style.left = minPercent + '%';
    range.style.width = (maxPercent - minPercent) + '%';
  }

  onSliderChange(event) {
    const slider = event.target;
    const value = Number(slider.value);
    
    if (slider === this.minSlider) {
      // 最小値スライダーが最大値スライダーを超えないようにする
      if (value > Number(this.maxSlider.value)) {
        this.minSlider.value = this.maxSlider.value;
        this.updateFromSlider('min');
      } else {
        this.updateFromSlider('min');
      }
    } else if (slider === this.maxSlider) {
      // 最大値スライダーが最小値スライダーを下回らないようにする
      if (value < Number(this.minSlider.value)) {
        this.maxSlider.value = this.minSlider.value;
        this.updateFromSlider('max');
      } else {
        this.updateFromSlider('max');
      }
    }
    
    this.setMinAndMaxValues();
    this.updateDisplay();
    this.updateSliderRange();
  }

  onInputChange(event) {
    const input = event.target;
    this.adjustToValidValues(input);
    this.setMinAndMaxValues();
    
    // スライダーを更新
    if (input === this.minInput && this.minSlider) {
      this.minSlider.value = input.value || 0;
    } else if (input === this.maxInput && this.maxSlider) {
      this.maxSlider.value = input.value || this.maxSlider.getAttribute('max');
    }
    
    this.updateDisplay();
    this.updateSliderRange();
  }

  updateFromSlider(type) {
    if (type === 'min' && this.minInput) {
      this.minInput.value = this.minSlider.value;
      // inputイベントを手動でトリガーしてフォーム送信を促す
      // これによりFacetFiltersFormのdebouncedOnSubmitが呼ばれる
      this.minInput.dispatchEvent(new Event('input', { bubbles: true }));
    } else if (type === 'max' && this.maxInput) {
      this.maxInput.value = this.maxSlider.value;
      // inputイベントを手動でトリガーしてフォーム送信を促す
      // これによりFacetFiltersFormのdebouncedOnSubmitが呼ばれる
      this.maxInput.dispatchEvent(new Event('input', { bubbles: true }));
    }
  }

  updateDisplay() {
    if (this.minValueDisplay && this.minInput) {
      const currency = this.minValueDisplay.textContent.match(/[^\d.,]+/)?.[0] || '';
      this.minValueDisplay.textContent = currency + (this.minInput.value || 0);
    }
    if (this.maxValueDisplay && this.maxInput) {
      const currency = this.maxValueDisplay.textContent.match(/[^\d.,]+/)?.[0] || '';
      this.maxValueDisplay.textContent = currency + (this.maxInput.value || this.maxSlider?.getAttribute('max') || 0);
    }
  }

  setMinAndMaxValues() {
    if (!this.minInput || !this.maxInput) return;
    
    const minValue = Number(this.minInput.value) || 0;
    const maxValue = Number(this.maxInput.value) || Number(this.maxInput.getAttribute('max')) || 0;
    
    if (maxValue) this.minInput.setAttribute('max', maxValue);
    if (minValue) this.maxInput.setAttribute('min', minValue);
    if (this.minInput.value === '') this.maxInput.setAttribute('min', 0);
    if (this.maxInput.value === '') {
      const max = this.maxInput.getAttribute('max');
      this.minInput.setAttribute('max', max);
    }
  }

  adjustToValidValues(input) {
    const value = Number(input.value);
    const min = Number(input.getAttribute('min')) || 0;
    const max = Number(input.getAttribute('max')) || 0;

    if (value < min) input.value = min;
    if (value > max && max > 0) input.value = max;
  }
}

customElements.define('price-range', PriceRange);

class FacetRemove extends HTMLElement {
  constructor() {
    super();
    const facetLink = this.querySelector('a');
    facetLink.setAttribute('role', 'button');
    facetLink.addEventListener('click', this.closeFilter.bind(this));
    facetLink.addEventListener('keyup', (event) => {
      event.preventDefault();
      if (event.code.toUpperCase() === 'SPACE') this.closeFilter(event);
    });
  }

  closeFilter(event) {
    event.preventDefault();
    const form = this.closest('facet-filters-form') || document.querySelector('facet-filters-form');
    form.onActiveFilterClick(event);
  }
}

customElements.define('facet-remove', FacetRemove);
